import { render, staticRenderFns } from "./L02GPGPUParticleRainbow.vue?vue&type=template&id=9c7e5f54&"
import script from "./L02GPGPUParticleRainbow.vue?vue&type=script&lang=js&"
export * from "./L02GPGPUParticleRainbow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports